import * as commonConsts from '../../../../pages/common/CommonConsts';

const documentUploads = [
  {
    organisationType: commonConsts.ORG_TYPE_Unincorporated,
    documentUploadTypes: [
      { type: commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules },
      { type: commonConsts.DOC_UPLOAD_TYPE_StatementObjects }
    ]
  },
  {
    organisationType: commonConsts.ORG_TYPE_IncorporatedAssociationNSW,
    documentUploadTypes: [
      { type: commonConsts.DOC_UPLOAD_TYPE_CertificateIncorporation },
      { type: commonConsts.DOC_UPLOAD_TYPE_StatementObjects }
    ]
  },
  {
    organisationType: commonConsts.ORG_TYPE_CompanyLimitedGuarantee,
    documentUploadTypes: [
      { type: commonConsts.DOC_UPLOAD_TYPE_CertificateRegistration },
      { type: commonConsts.DOC_UPLOAD_TYPE_StatementObjects },
      { type: commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules }
    ]
  },
  {
    organisationType: commonConsts.ORG_TYPE_CompanyLtdShares,
    documentUploadTypes: [
      { type: commonConsts.DOC_UPLOAD_TYPE_CertificateRegistration },
      { type: commonConsts.DOC_UPLOAD_TYPE_StatementObjects },
      { type: commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules }
    ]
  },
  {
    organisationType: commonConsts.ORG_TYPE_Other,
    documentUploadTypes: [
      { type: commonConsts.DOC_UPLOAD_TYPE_Certificate },
      { type: commonConsts.DOC_UPLOAD_TYPE_StatementObjects },
      { type: commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules }
    ]
  },
  {
    organisationType: commonConsts.ORG_TYPE_TrustDeed,
    documentUploadTypes: [
      { type: commonConsts.DOC_UPLOAD_TYPE_TrustDeed },
      { type: commonConsts.DOC_UPLOAD_TYPE_StatementObjects }
    ]
  }
];

const getDocumentError = (errors, organisationType, documentUploadType) => {
  if (organisationType === commonConsts.ORG_TYPE_Unincorporated) {
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules) {
      return errors.hasUnincorporateConstitutionDocument;
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects) {
      return errors.hasUnincorporateStatementObjectDocuments;
    }
  }

  if (organisationType === commonConsts.ORG_TYPE_IncorporatedAssociationNSW) {
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_CertificateIncorporation) {
      return errors.hasIncorporateCertificateIncDocuments;
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects) {
      return errors.hasIncorporateStatementObjectDocuments;
    }
  }

  if (organisationType === commonConsts.ORG_TYPE_CompanyLimitedGuarantee) {
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_CertificateRegistration) {
      return errors.hasCompanyGuaranteeCertRegDocuments;
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects) {
      return errors.hasCompanyGuaranteeStatementObjDocuments;
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules) {
      return errors.hasCompanyGuaranteeConstitutionDocuments;
    }
  }

  if (organisationType === commonConsts.ORG_TYPE_CompanyLtdShares) {
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_CertificateRegistration) {
      return errors.hasCompanySharesCertRegDocuments;
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects) {
      return errors.hasCompanySharesStatementObjDocuments;
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules) {
      return errors.hasCompanySharesConstitutionDocuments;
    }
  }

  if (organisationType === commonConsts.ORG_TYPE_Other) {
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_Certificate) {
      return errors.hasOtherCertificateDocumentsDocuments;
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects) {
      return errors.hasOtherConstitutionDocuments;
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules) {
      return errors.hasOtherStatementObjectDocuments;
    }
  }

  if (organisationType === commonConsts.ORG_TYPE_TrustDeed) {
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_TrustDeed) {
      return errors.hasTrustDeedDocuments;
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects) {
      return errors.hasTrustStatementObjectDocuments;
    }
  }
};

export { documentUploads, getDocumentError };
